/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Toast_Delete_LoadingInputs */

const es_components_credentials_toast_delete_loading = /** @type {(inputs: Components_Credentials_Toast_Delete_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminando credencial...`)
};

const en_components_credentials_toast_delete_loading = /** @type {(inputs: Components_Credentials_Toast_Delete_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting credential...`)
};

/**
* | output |
* | --- |
* | "Deleting credential..." |
*
* @param {Components_Credentials_Toast_Delete_LoadingInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_toast_delete_loading = /** @type {((inputs?: Components_Credentials_Toast_Delete_LoadingInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Toast_Delete_LoadingInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_toast_delete_loading(inputs)
	return en_components_credentials_toast_delete_loading(inputs)
});
export { components_credentials_toast_delete_loading as "components.credentials.toast.delete.loading" }